import { Component, OnDestroy, OnInit } from '@angular/core';
import { AggregateField, Firestore, collection } from '@angular/fire/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import * as moment from 'moment';
import { Subscription, take, takeUntil } from 'rxjs';
import { P } from '@angular/cdk/keycodes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss'],
})
export class DashboardAdminComponent {
  tableData: any[] = [];
  inprogressIcon = '../../../assets/images/wip.png';
  appointmentDetails: any[] = [];
  subspription!: Subscription;
  todayApt: any[] = [];
  comingApt: any[] = [];
  completedApt: any[] = [];
  newClients!: number;
  activeClients!: number;
  totalRecAmnt = 0;
  constructor(
    private angularFirestore: AngularFirestore,
    private pdfGenerator: PdfGeneratorService,
    private firestore: AngularFirestore,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.subspription.unsubscribe();
  }

  ngOnInit(): void {
    this.getAptDetails();
    this.firestore
      .collection('clientProfile', (ref) => ref.where('status', '==', 'New'))
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        this.newClients = data.length;
      });
    this.firestore
      .collection('clientProfile', (ref) => ref.where('status', '==', 'Active'))
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) => {
        this.activeClients = data.length;
      });
    const usersCollection = this.firestore.collection('clientProfile', (ref) =>
      ref.where('amntReceived', '>', 0)
    );
    const sumQuery = usersCollection
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data) =>
        data.forEach(
          (x: any) =>
            (this.totalRecAmnt = this.totalRecAmnt + Number(x.amntReceived))
        )
      );
  }

  getAptDetails() {
    this.subspription = this.firestore
      .collection('appointmentDetails')
      .snapshotChanges()
      .pipe(take(1))
      .subscribe((data: any) => {
        data.forEach((e: any) => {
          const obj: any = e.payload.doc.data();
          this.transformDate(obj);
          this.appointmentDetails.push(obj);
        });
        let todayApt: any = [];
        const currentDate = moment(new Date()).format('DD/MM/YYYY');
        this.appointmentDetails.filter((x: any) => {
          let todayApt = x.appointDetails.filter(
            (apt: any) =>
              apt.appotStatus === 'Scheduled' && apt.appotDate === currentDate
          )[0];
          let comingApt = x.appointDetails.filter(
            (apt: any) =>
              apt.appotStatus === 'Scheduled' && apt.appotDate !== currentDate
          )[0];
          let completedApt = x.appointDetails.filter(
            (apt: any) =>
              apt.appotStatus === 'Expired' || apt.appotStatus === 'Completed'
          )[0];
          if (todayApt) {
            this.todayApt.push(todayApt);
          } else if (comingApt) {
            this.comingApt.push(comingApt);
          } else if (completedApt) {
            this.completedApt.push(completedApt);
          }
        });
      });
  }

  transformDate(obj: any) {
    obj.appointDetails.map(
      (x: any) =>
        (x.appotDate = moment(x.appotDate.toDate()).format('DD/MM/YYYY'))
    );
  }

  getApt(apt: any) {
    const aptData = apt.appointDetails.filter(
      (x: any) => x.appotStatus === 'Scheduled'
    )[0];
    return aptData;
  }

  routeTo(row: any) {
    this.router.navigate(['./layout/edit-diet-plan/' + row.userUID]);
  }
}
